/* eslint-disable react/prop-types */
import React from "react";
import { connect } from "react-redux";
import GeneTranscripts from "../components/Transcripts/GeneTranscripts";
import CGD from "../components/CGD/CGD";
import UnilDomino from "../components/UnilDomino";
import PanelApp from "../components/PanelApp/PanelApp";
import DbNSFPGenes from "../components/dpnfspGenes/DbNSFPGenes";
import GHRGenes from "../components/GHRGenes";
import SaphetorKnownPathogenicity from "../components/SaphetorKnownPathogenicity";
import GeneGTEx from "../components/GTEx/GeneGTEx";
import HPOTreeContainer from "../../../components/HPOTreeContainer";
import GnomadGenes from "../components/GnomadGenes/GnomadGenes";
import ClinGen from "../components/clinGen/ClinGen";
import ProteinAtlas from "../components/ProteinAtlas";
import FusionGDB from "../components/FusionGDB";
import GeneBasicInfo from "../components/GeneBasicInfo/GeneBasicInfo";
import PMKBGene from "../../variant/components/cancer-dbs/PMKBGene";
import Civic from "../components/CIVIC/Civic";
import JaxCkbGeneComponent from "../components/JaxCKB/JaxCkbGeneComponent";
import CancerGeneCensus from "../components/CancerGeneCensus/CancerGeneCensus";
import PharmGKBDrugDatabase from "../components/drugDatabases/PharmGKBDrugDatabase";
import AACT from "../components/drugDatabases/AACT";
import DGI from "../components/drugDatabases/DGI/DGI";
import FDA from "../components/FDA/FDA";
import CPIC from "../components/CPIC/CPIC";
import EBIGene2Phenotype from "../components/EBIGene2Phenotype";
import GenCC from "../components/GenCC";
import NIHClinGenDiseaseValidity from "../components/NIHClinGenDiseaseValidity";
import OmimGene from "../../../components/OMIM/OmimGene";
import {
  getCardsOptions,
  getVariantResult,
} from "../../../state/selectors/general.selectors";
import LovdGene from "../components/LOVD/LovdGene";

const GenesResults = ({ variantResult, cardId }) => {
  let content = null;
  if (variantResult) {
    switch (cardId) {
      case "geneBasicInfo":
        content = (
          <GeneBasicInfo
            selectedGene={variantResult}
            genes={variantResult?.genes}
          />
        );
        break;
      case "geneGHR":
        content = (
          <GHRGenes
            data={variantResult?.ghr_genes}
            gene={variantResult?.symbol}
          />
        );
        break;
      case "geneTranscripts":
        content = <GeneTranscripts data={variantResult?.transcripts} />;
        break;
      case "geneKnownPathogenicity":
        content = (
          <SaphetorKnownPathogenicity
            data={variantResult?.saphetor_known_pathogenicity}
            gene={variantResult?.symbol}
          />
        );
        break;
      case "geneGTEx":
        content = <GeneGTEx data={variantResult?.nih_gtex} />;
        break;
      case "dbnsfpGenes":
        content = (
          <DbNSFPGenes
            data={variantResult?.dbnsfp_genes}
            gene={variantResult?.symbol}
          />
        );
        break;
      case "geneGnomad":
        content = <GnomadGenes data={variantResult?.gnomad_genes} />;
        break;
      case "geneEbiGene2Phenotype":
        content = (
          <EBIGene2Phenotype data={variantResult?.ebi_gene_2_phenotype} />
        );
        break;
      case "geneGenCc":
        content = <GenCC data={variantResult?.gen_cc} />;
        break;
      case "geneNihClinGenDiseaseValidity":
        content = (
          <NIHClinGenDiseaseValidity
            data={variantResult?.nih_clin_gen_disease_validity}
          />
        );
        break;
      case "geneClingen":
        content = <ClinGen data={variantResult?.clingen_gene} />;
        break;
      case "unilDomino":
        content = (
          <UnilDomino
            data={variantResult?.unil_domino}
            gene={variantResult?.symbol}
          />
        );
        break;
      case "hpoTree":
        content = (
          <HPOTreeContainer
            HPOTree={variantResult?.hpo_tree}
            geneSymbol={variantResult?.symbol}
          />
        );
        break;
      case "panelApp":
        content = <PanelApp data={variantResult?.genomics_england_panelapp} />;
        break;
      case "cgd":
        content = <CGD data={variantResult?.cgd} />;
        break;
      case "proteinAtlas":
        content = <ProteinAtlas data={variantResult?.protein_atlas} />;
        break;
      case "fusionGdb":
        content = <FusionGDB data={variantResult?.fusiongdb} />;
        break;
      case "genePmkb":
        content = (
          <PMKBGene data={variantResult?.weill_cornell_medicine_pmkb} />
        );
        break;
      case "geneCivic":
        content = <Civic data={variantResult?.civic} />;
        break;
      case "geneJax":
        content = <JaxCkbGeneComponent data={variantResult?.jax_ckb} />;
        break;
      case "cancerGeneCensus":
        content = <CancerGeneCensus data={variantResult?.cancer_gene_census} />;
        break;
      case "pharmGKBGene":
        content = <PharmGKBDrugDatabase result={variantResult?.pharmgkb} />;
        break;
      case "aact":
        content = <AACT data={variantResult?.aact} />;
        break;
      case "dgi":
        content = <DGI data={variantResult?.dgi} />;
        break;
      case "fda":
        content = <FDA data={variantResult?.fda_pharmacogenomic_biomarkers} />;
        break;
      case "cpic":
        content = <CPIC data={variantResult?.cpic} />;
        break;
      case "omimGene":
        content = <OmimGene data={variantResult?.omim} />;
        break;
      case "lovdGene":
        content = <LovdGene data={variantResult?.lovd_gene} />;
        break;
      default:
        content = null;
        break;
    }
  }

  return <div className="genes-page">{content}</div>;
};

const mapStateToProps = (state) => ({
  cardOptions: getCardsOptions(state),
  variantResult: getVariantResult(state),
});

export default connect(mapStateToProps)(GenesResults);
